export default __webpack_public_path__ + "static/media/O-049.252ddcf7.png";